// Upgrade effect constants
const RAPID_FIRE_MULTIPLIER = 2;
const DAMAGE_BOOST_1_PERCENTAGE = 50;
const DAMAGE_BOOST_2_PERCENTAGE = 100;
const TRIPLE_SHOT_COUNT = 3;
const SHIELD_CAPACITY_1_PERCENTAGE = 50;
const SHIELD_CAPACITY_2_PERCENTAGE = 100;
const SHIELD_RECHARGE_MULTIPLIER = 2;

/**
 * All upgrade definitions - TypeScript derives the upgrade IDs from the keys
 */
export const upgradeDefinitions = {
  rapidFire: {
    name: "Rapid Fire",
    description: `Fire bullets ${RAPID_FIRE_MULTIPLIER}x as fast`,
    rarity: "common",
  },
  damageBoost1: {
    name: "Damage Boost I",
    description: `Bullets deal ${DAMAGE_BOOST_1_PERCENTAGE}% more damage`,
    rarity: "common",
  },
  damageBoost2: {
    name: "Damage Boost II",
    description: `Bullets deal ${DAMAGE_BOOST_2_PERCENTAGE}% more damage`,
    rarity: "rare",
    dependencies: ["damageBoost1"],
  },
  tripleShot: {
    name: "Triple Shot",
    description: `Fire ${TRIPLE_SHOT_COUNT} bullets at once`,
    rarity: "rare",
    dependencies: ["rapidFire"],
  },
  piercingBullets: {
    name: "Piercing Bullets",
    description: "Bullets go through enemies",
    rarity: "rare",
    dependencies: ["damageBoost1"],
  },
  shieldCapacity1: {
    name: "Shield Boost I",
    description: `Increase shield capacity by ${SHIELD_CAPACITY_1_PERCENTAGE}%`,
    rarity: "common",
  },
  shieldCapacity2: {
    name: "Shield Boost II",
    description: `Increase shield capacity by ${SHIELD_CAPACITY_2_PERCENTAGE}%`,
    rarity: "rare",
    dependencies: ["shieldCapacity1"],
  },
  fastRecharge: {
    name: "Fast Recharge",
    description: `Shield recharges ${SHIELD_RECHARGE_MULTIPLIER}x as fast`,
    rarity: "common",
    dependencies: ["shieldCapacity1"],
  },
  autoTarget: {
    name: "Auto Target",
    description: "Auto-aim at nearest enemy",
    rarity: "epic",
    dependencies: ["tripleShot", "piercingBullets"],
  },
  bombMagnet: {
    name: "Bomb Magnet",
    description: "Attract nearby bombs for easier shooting",
    rarity: "rare",
    dependencies: ["fastRecharge"],
  },
} as const satisfies Record<
  string,
  {
    name: string;
    description: string;
    rarity: "common" | "rare" | "epic";
    dependencies?: string[];
  }
>;

export type UpgradeId = keyof typeof upgradeDefinitions;
